import { useCallback, useState } from 'react';

import { Content, Layout } from 'apps/dashboard/shared/scripts/components';
import {
  CardFilter,
  SortInput,
  SortOrder,
} from 'apps/shared/scripts/__generated__/graphql.generated';
import { useCards } from 'apps/shared/scripts/graphql';

import {
  CardsList,
  FilterCards,
  LoadingCards,
  SortCards,
} from '../../components';

import messages from './messages.json';

const CARD_FETCH_LIMIT = 10;

const CardsContainer = () => {
  const [sort, setSort] = useState<SortInput>({
    sortBy: 'createdAt',
    sortOrder: SortOrder.Desc,
  });
  const [filter, setFilter] = useState<CardFilter>({});
  const { cards, isLoading, fetchMore, cursor, hasNextPage, refetch } =
    useCards({
      fetchPolicy: 'cache-and-network',
      variables: {
        first: CARD_FETCH_LIMIT,
        ...sort,
        filter,
      },
    });

  const onSort = useCallback(
    async (sortInput: SortInput) => {
      setSort(sortInput);
      await refetch({
        first: 100,
        ...sortInput,
        filter,
      });
    },
    [filter, refetch],
  );

  const onFilter = useCallback(
    async (cardFilter: CardFilter) => {
      setFilter(cardFilter);
      await refetch({
        first: 100,
        ...sort,
        filter: {
          ...cardFilter,
        },
      });
    },
    [refetch, sort],
  );

  return (
    <Layout>
      <Content
        rightHeader={
          <>
            <FilterCards filter={filter} onFilter={onFilter} />
            <SortCards sort={sort} onSort={onSort} />
          </>
        }
        title={messages.cardsTitle}
      >
        {isLoading ? (
          <LoadingCards />
        ) : (
          <CardsList
            cards={cards}
            cursor={cursor}
            fetchMore={fetchMore}
            hasNextPage={hasNextPage}
          />
        )}
      </Content>
    </Layout>
  );
};

CardsContainer.displayName = 'CardsContainer';

export default CardsContainer;
